import { CheckCircleOutline } from '@mui/icons-material'
import { Box, Stack, Typography, useTheme } from '@mui/material'

import FEATURES from '~/features/onboarding/components/firstAssistantOnboarding/featuresCard/utils'
import rem from '~/utils/ui'

function FeaturesCard() {
  const theme = useTheme()

  return (
    <Stack
      sx={{
        padding: rem(24),
        backgroundColor: theme.palette.background.paper,
        borderRadius: rem(16),
        boxShadow: theme.shadows[2],
        alignItems: { xxxs: 'flex-start', md: 'center' },
        justifyContent: { xxxs: 'flex-start', md: 'center' },
      }}
      useFlexGap
    >
      <Stack useFlexGap>
        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            fontSize: rem(24),
            color: theme.palette.text.primary,
            marginBottom: rem(40),
          }}
        >
          What you&apos;ll get with your first assistant:
        </Typography>

        <Stack spacing={4} useFlexGap>
          {FEATURES.map((feature) => (
            <Stack
              key={feature.title}
              direction="row"
              spacing={rem(12)}
              alignItems="flex-start"
            >
              <CheckCircleOutline
                sx={{
                  fontSize: rem(22),
                  color: theme.palette.primaryButtonBg,
                }}
              />
              <Box>
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontWeight: 700,
                    fontSize: rem(16),
                    color: theme.palette.text.primary,
                    marginBottom: rem(2),
                    lineHeight: 1.3,
                  }}
                >
                  {feature.title}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: rem(14),
                    color: theme.palette.text.secondary,
                    lineHeight: 1.4,
                  }}
                >
                  {feature.description}
                </Typography>
              </Box>
            </Stack>
          ))}
        </Stack>
      </Stack>
    </Stack>
  )
}

export default FeaturesCard
